import script from "./IndustryModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndustryModel.vue?vue&type=script&lang=ts&setup=true"

import "./IndustryModel.vue?vue&type=style&index=0&id=b5d32b06&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5d32b06"]])

export default __exports__